import { SolucionareErrors } from '../../types/enums';

export const SOLUCIONARE_ERRORS: { [key: string]: SolucionareErrors } = {
  'Obrigatório informar nomeRelacional e token.':
    SolucionareErrors.INVALID_TOKEN_INVALID_RELATIONAL_NAME,
  'Nome relacional informado inválido.': SolucionareErrors.INVALID_RELATIONAL_NAME,
  'Token informado inválido.': SolucionareErrors.INVALID_TOKEN,
};
